module.exports = __webpack_public_path__ + "media/images/add-profile-538595070d8c7870fc4f211940eb2c23.png";